<!--弃用-->
<script setup>
import MallOrder from './MallOrder.vue'
import PurchasingOrder from './PurchasingOrder.vue'
import tabsView from '@/components/tabsView/index.vue'
const tabsList=[
    {id:1,name:$t('setup449')},
    {id:2,name:$t('setup456')}
]
const orderType=ref(1)
//切换tabs（1.商城订单，2代购）
const setCheckTabs=(data)=>{
    orderType.value=data
}
</script>
<template>
    <div class="buyOrder">
        <div class="buy-title">
            我买入的
        </div>
        <tabsView :tabsList="tabsList" @setCheckTabs="setCheckTabs"></tabsView>
        <div v-if="orderType==1">
            <MallOrder></MallOrder>
        </div>
        <div v-else>
            <PurchasingOrder></PurchasingOrder>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .buyOrder{
        .buy-title{
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 18px;
            color: #11192D;
            line-height: 18px;
            text-align: left;
            font-style: normal;
            padding: 30px 20px;
        }
    }
</style>